import { ArrowUnionVertical } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowUnionVertical12Line = createIcon(
  ArrowUnionVertical,
  12,
  "Line"
);
export const IconArrowUnionVertical16Line = createIcon(
  ArrowUnionVertical,
  16,
  "Line"
);
export const IconArrowUnionVertical20Line = createIcon(
  ArrowUnionVertical,
  20,
  "Line"
);
export const IconArrowUnionVertical24Line = createIcon(
  ArrowUnionVertical,
  24,
  "Line"
);
export const IconArrowUnionVertical32Line = createIcon(
  ArrowUnionVertical,
  32,
  "Line"
);
export const IconArrowUnionVertical48Line = createIcon(
  ArrowUnionVertical,
  48,
  "Line"
);
export const IconArrowUnionVertical64Line = createIcon(
  ArrowUnionVertical,
  64,
  "Line"
);
